module.exports = __webpack_public_path__ + "static/media/tm.d8dfb14b.svg";